import React, { useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch} from 'react-redux';
import { Loader, Modal, Button } from 'rsuite';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import * as actionsAdmin  from '../../../../app/actions/admin';
import { UploadPicture, dataUrlToFile} from '../elements/UploadHelpers';
import { uploadNews} from '../../../../app/common/services/fetch.admin.service';
import NewsCard from './NewsCard';

const AdminMain = ({style}) => {

    const dispatch = useDispatch();

    const [header, setHeader] = useState('');
    let [textData, setTextData] = useState('');

    const [description, setDescription] = useState('');

    const [picture, setPicture] = useState({uploaded: false, data: null, name: '', contentType: ""});
    const [showUpload, setShowUpload] = useState(false)

    const [showModal, setShowModal] = useState({show: false, msg: ''});
    const [loading, setLoading] = useState(false);

    const onImageUpload = useCallback((image) => {
        console.log(image)
        if(image) {
            setPicture({uploaded: true, name: image.file?.name, data: URL.createObjectURL(image.file), contentType: image.contentType});
           // setTalonPicture(image.file, image.contentType);
        }
        setShowUpload(false);
    }, []);

    const onSubmit = async () => {
        if(!picture?.uploaded || !header || !textData || !description) {
            //console.log(header, textData)
            return setShowModal({show:true, msg: 'Липсват данни'});
        }

        setLoading(true);

        //textData = new Blob([textData]);

        let resPic;

        try{
            const file = await dataUrlToFile(picture.data, 'newsImage', picture.contentType);

            resPic = await uploadNews(file, header, textData, picture.contentType, description);
        } catch (error) {
          console.log(error);
        }

        if(resPic?.data && resPic?.data.newsId){
            setShowModal({show: true, msg: `Новината е качена успешно`});
            dispatch(actionsAdmin.getNews());
            setHeader('');
            setTextData('');
            setDescription('');
            setPicture({uploaded: false, data: null, name: '', contentType: ""});
            setLoading(false);

        }else {
            setShowModal({show: true, msg: `Новината не беше качена, моля опитайте отново`});
            setLoading(false);
        }       
    }

    return (
        <div className="admin-container" style={style}>
            <h3 className="module-title">Admin Module</h3>
            <div className="upload-container">
                <div className="left-box">
                    {picture?.uploaded 
                    ? <img src={picture.uploaded ? picture.data : null} alt="Picture 280x200 WxH" />
                    : <div className="pic-demo-box"><div className="demo-text">Picture 280x200 WxH</div></div>
                    }
                </div>
                <div className="right-box">
                    <button className="nuIns-btn nuIns-btn-heaven"  onClick={()=>setShowUpload(true)}>{picture?.uploaded ? 'Edit picture' : 'Upload picture'}</button>
                    <p className="pic-name">{picture?.name}</p>
                </div>
                <div className="preview-box">
                    <NewsCard news={{image: picture.data, title: header, textData: textData}} />
                </div>
            </div>
           {showUpload
            ? <UploadPicture onChange={onImageUpload} />
            : null
           }
           <h5 className="header-label">Title</h5>
           <input className="header-input" type='text' onChange={(ev) => {setHeader(ev.target.value);}} value={header}></input>
           <h5 className="header-label">Short description</h5>
           <input className="header-input" type='text' onChange={(ev) => {setDescription(ev.target.value);}} value={description} ></input>
           <h5 className="text-editor-label">Text</h5>
            <CKEditor
                editor={ ClassicEditor }
                data={textData}
                onReady={ editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log( 'Editor is ready to use!', editor );
                } }
                onChange={ ( event, editor ) => {
                    const data = editor.getData();
                    setTextData(data);
                   // console.log( { event, editor, data } );
                } }
                onBlur={ ( event, editor ) => {
                    //console.log( 'Blur.', editor );
                } }
                onFocus={ ( event, editor ) => {
                    //console.log( 'Focus.', editor );
                } }
            />
             <button className="nuIns-btn nuIns-btn-heaven submit-btn"  onClick={onSubmit}>Submit</button>

             {loading ? <Loader backdrop center size="lg"  speed="slow" /> : null}

            <Modal size="xs" className="nuins-ok-modal" show={showModal?.show} onHide={() => setShowModal({show:false, msg:''})}>
                <Modal.Body>
                    <p className="">{showModal?.msg}</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => setShowModal({show:false, msg:''})} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AdminMain;

/*
 if(resPic?.data && resPic?.data.status === 0 ) {
          
          picRefNo =  resPic.data.refNo;
          console.log(picRefNo);
        } else if (resPic?.data.messageCode && resPic?.data.status === 1){
            setShowModal({show: true, msg: `Upload pic: ${resPic?.data.messageCode}`})
            setLoading(false);
            return;
        }
        setLoading(false);

        if(picRefNo) {
            const newNews = {picRefNo, title: header, textData};
            try{
                resNews = await uploadNews(newNews);
            } catch (error) {
              console.log(error);
            }
    
            if(resNews?.data && resNews?.data?.newsId ) {
                dispatch(actionsAdmin.addNews(newNews));
                setShowModal({show: true, msg: `Новината е качена успешно`});
                setHeader('');
                setTextData('');
                setPicture({uploaded: false, data: null, name: '', contentType: ""});
    
            } else if (resNews?.data.messageCode && resNews?.data.status === 1){
                setShowModal({show: true, msg: `${resPic?.data.messageCode}`})
            }
    
            setLoading(false);
        }
        */